import { render, staticRenderFns } from "./AddRuleTemplate.vue?vue&type=template&id=f1e1944c&"
import script from "./AddRuleTemplate.vue?vue&type=script&lang=js&"
export * from "./AddRuleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddRuleTemplate.vue"
export default component.exports